import styled from '@emotion/styled';

const DisplayLink = styled.button(({theme, disabled}) => `
    color: ${disabled ? theme.disabledFontColor : theme.highlightColor};
    display: block;
    cursor: ${disabled ? 'default' : 'pointer'};
    font-family: ${theme.fontFamily};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.5px;
    line-height: 18px;
    margin-top: 16px;

    &:hover {
      text-decoration: ${disabled ? 'none' : 'underline'};
    }
`);

DisplayLink.defaultProps = {
  children: 'Gegevens aanpassen',
  type: 'button',
}

export default DisplayLink;
